import theme from '../../styles/themes';

function ArrowFilterIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            width={20}
            height={20}
            {...props}
        >
            <path
                stroke={`${props.fill || theme.colors.primary}`}
                strokeWidth={4}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1 33l16-16L1 1"
                fill="none"
            />
        </svg>
    );
}

export default ArrowFilterIcon;
